<!-- Breadcrumb -->
<div *ngIf="app?.isPlatformBrowserVar" class="breadcrumb-bar" data-aos="fade-in" data-aos-duration="800">
    <div class="container-fluid">
        <div class="row align-items-center">
            <div class="col-md-8 col-12">
                <nav aria-label="breadcrumb" class="page-breadcrumb">
                    <ol class="breadcrumb nav-family-font">
                        <mat-icon class="home-icon" aria-hidden="false" aria-label="Example home icon">home</mat-icon>
                        <li class="breadcrumb-item"><a [routerLink]="'/' + this?.app?.languageCode + '/home'">{{
                                'navigationBar.Home' | translate }}</a>
                        </li>
                        <i *ngIf="this.app?.getUserLanguage() == 'en'" class="fa fa-angle-right nav-font"></i>
                        <i *ngIf="this.app?.getUserLanguage() == 'ar'" class="fa fa-angle-left nav-font"></i>
                        <li class="breadcrumb-item active" aria-current="page">{{ 'navigationBar.Search Doctor' |
                            translate }}</li>
                    </ol>
                </nav>
            </div>
        </div>
    </div>
</div>
<!-- /Breadcrumb -->


<!-- Page Content -->
<div *ngIf="app?.isPlatformBrowserVar" class="content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-3">

                <!-- Search Filter -->
                <div class="card search-filter pos-fixed">
                    <form class="shadow-boxx" [formGroup]="form" data-aos="fade-in" data-aos-duration="800">
                        <div class="card-header bg-light-grey">
                            <h4 class="card-title mb-0">{{ 'SearchDoctor.SearchFilter' | translate }}</h4>
                        </div>
                        <div class="card-body bg-light-grey">

                            <!-- <DoctorName> -->
                            <div class="form-group col-12 card-label mt-3">
                                <!-- <label>{{ 'SearchDoctor.DoctorName' | translate }}</label> -->
                                <input placeholder="{{ 'SearchDoctor.DoctorName' | translate }}"
                                    formControlName="searchText" class="form-control pt-0" type="text" name="firstname">
                            </div>
                            <!-- </DoctorName> -->

                            <!-- <genderEnglish> -->
                            <div *ngIf="this.app?.getUserLanguage() == 'en'"
                                class="form-group mb-0 col-12 selectC mt-3">
                                <ng-select formControlName="gender" [items]="genders" bindLabel="name" bindValue="id"
                                    placeholder="{{ 'SearchDoctor.SelectGender' | translate }}" appendTo="body"
                                    [multiple]="false" [(ngModel)]="gendersValues">
                                </ng-select>
                            </div>
                            <!-- </genderEnglish> -->
                            <!-- <genderArabic> -->
                            <div *ngIf="this.app?.getUserLanguage() == 'ar'"
                                class="form-group mb-0 col-12 selectC mt-3">
                                <ng-select formControlName="gender" [items]="gendersAr" bindLabel="name" bindValue="id"
                                    placeholder="{{ 'SearchDoctor.SelectGender' | translate }}" appendTo="body"
                                    [multiple]="false" [(ngModel)]="gendersValues">
                                </ng-select>
                            </div>
                            <!-- </genderArabic> -->

                            <!-- <language> -->
                            <div class="form-group col-12 mb-0 selectC mt-3">
                                <ng-select formControlName="languageIds" [items]="languages" bindLabel="name"
                                    bindValue="id" placeholder="{{ 'SearchDoctor.Select Languages' | translate }}"
                                    appendTo="body" [multiple]="true" [(ngModel)]="languagesValues"
                                    [closeOnSelect]="false">
                                </ng-select>
                            </div>
                            <!-- </language> -->


                            <!-- <insuranceCompanyIds> -->
                            <div class="form-group col-12 mb-0 selectC mt-3">
                                <ng-select formControlName="insuranceCompanyIds" [items]="healthCareInsurance"
                                    bindLabel="name" bindValue="id"
                                    placeholder="{{ 'SearchDoctor.Select Insurance Compines' | translate }}"
                                    [closeOnSelect]="false" appendTo="body" [multiple]="true"
                                    [(ngModel)]="healthCareInsuranceValue">
                                </ng-select>
                            </div>
                            <!-- </insuranceCompanyIds> -->

                            <!-- <servicesIds> -->
                            <div class="form-group col-12 mb-0 selectC mt-3">
                                <ng-select formControlName="servicesIds" [items]="medicalServices" bindLabel="name"
                                    bindValue="id"
                                    placeholder="{{ 'SearchDoctor.Select Medical Services' | translate }}"
                                    appendTo="body" [multiple]="true" [(ngModel)]="medicalServicesValue"
                                    [closeOnSelect]="false">
                                </ng-select>
                            </div>
                            <!-- </servicesIds> -->

                            <!-- <location> -->
                            <!-- <div *ngIf="app?.isPlatformBrowserVar" class="form-group col-12 card-label mb-3 mt-29">
                                <input [options]='options' type="text" class="form-control search-ortho pt-0"
                                    formControlName="locationPlaceholderNotMapped"
                                    placeholder="{{ 'SearchDoctor.enterLocation' | translate }}"
                                    ngx-google-places-autocomplete (onAddressChange)="AddressChange($event)" />
                            </div> -->

                            <div class="form-group col-12 mb-0 selectC mt-3">
                                <ng-select formControlName="locationId" [items]="allLocations" bindLabel="nameForSelect"
                                    bindValue="id" placeholder="{{ 'SearchDoctor.enterLocation' | translate }}"
                                    appendTo="body" [multiple]="false" [(ngModel)]="allLocationsValues"
                                    [closeOnSelect]="false">
                                </ng-select>
                            </div>
                            <!-- </location> -->



                            <div class="my-3">
                                <button (click)="search();" type="submit" class="btn w-100 submit-btn">{{
                                    'SearchDoctor.Search' | translate }}</button>
                            </div>


                            <div class="">
                                <button (click)="clearFilters();" class="btn w-100 clear-btn">{{
                                    'SearchDoctor.ClearFilters' | translate }}</button>
                            </div>

                        </div>
                    </form>
                </div>
                <!-- /Search Filter -->

            </div>

            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-9">

                <!-- Page Content -->
                <div class="content" id="content">
                    <div class="container-fluid">

                        <div class="row">

                            <!-- content-right-->

                            <div class="col-xl-12 col-lg-12 order-md-last order-sm-last order-last map-left">

                                <!-- header -->
                                <div class="col-xl-12 row align-items-center mb-2">


                                    <div class="justifyEnd-d-Flex">

                                        <h1 data-aos="fade-in" data-aos-duration="800" class="m-0 text-blue">
                                            {{headerTwo}}</h1>

                                        <!-- <SortBy> -->
                                        <mat-form-field class="w-14" appearance="outline" data-aos="fade-in"
                                            data-aos-duration="800">
                                            <mat-label class="pr-1">{{ 'SearchDoctor.SortBy' | translate }}</mat-label>
                                            <mat-select>
                                                <mat-option selected value="0"></mat-option>
                                                <mat-option (onSelectionChange)="sortByChange($event)" [value]="1">{{
                                                    'SearchDoctor.Rate' | translate }}
                                                </mat-option>
                                                <mat-option (onSelectionChange)="sortByChange($event)" [value]="2">{{
                                                    'SearchDoctor.Price' | translate }}
                                                </mat-option>
                                                <mat-option (onSelectionChange)="sortByChange($event)" [value]="3">{{
                                                    'SearchDoctor.Distance' | translate }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                        <!-- </SortBy> -->
                                    </div>
                                </div>
                                <!-- /header -->

                                <!-- mapList -->
                                <div class="row">
                                    <div class="col-sm-12 col-md-12 col-xl-12" *ngFor="let doctor of doctors">
                                        <!-- Doctor Widget -->
                                        <div class="card b-r-15" data-aos="fade-up" data-aos-duration="800">
                                            <div class="card-body shadow-boxx">
                                                <div class="row">

                                                    <div class="col-sm-12 col-md-8 col-lg-8 col-xl-8">
                                                        <div class="col-12">
                                                            <div class="d-flex">

                                                                <div class="d-inline-block mx-2 ">

                                                                    <a class="cursor-pointer"
                                                                        (click)="app.routeToDoctorProfile(doctor)">
                                                                        <img title="{{doctor?.fullName | splitStringToArEn}} - {{ doctor?.speciality | splitStringToArEn }}"
                                                                            class="w-h-forMap"
                                                                            [src]="app.getUserImage2(doctor?.picture)"
                                                                            alt="{{doctor?.fullName | splitStringToArEn}} - {{ doctor?.speciality | splitStringToArEn }}" />
                                                                        <!-- <img class="w-h-forMap" alt="User Image" [src]="app.getDoctorImage(doctor?.picture, doctor?.gender)"> -->
                                                                        <!-- <app-img-loader [className]="'searchDoctorIcon'"
                                                                            [src]="doctor?.picture"></app-img-loader> -->

                                                                    </a>
                                                                </div>
                                                                <div class="d-inline-block p-00">
                                                                    <div class="row">
                                                                        <h4 class="doc-name-info cursor-pointer mb-1"><a
                                                                                class="text-w"
                                                                                (click)="app.routeToDoctorProfile(doctor)">{{doctor.fullName
                                                                                | splitStringToArEn}}</a>
                                                                        </h4>
                                                                        <h5 class="docSpachility mb-1">
                                                                            {{doctor.speciality| splitStringToArEn}}
                                                                        </h5>
                                                                        <!-- <div>
                                                                            <span style="color:#F6C64B;font-size: 25px;">★</span>
                                                                            <span style="color:#F6C64B;font-size: 25px;">★</span>
                                                                            <span style="color:#F6C64B;font-size: 25px;">★</span>
                                                                            <span style="color:#F6C64B;font-size: 25px;">★</span>
                                                                            <span style="color:#DDDDDD;font-size: 25px;">★</span>
                                                                        </div> -->
                                                                        <div class="mb-1" *ngIf="doctor?.rate">
                                                                            <!-- {{doctor?.rate | star}} -->
                                                                            <div class="d-flex align-items-center">
                                                                                <!-- <div class="mb-1">{{doctorDetails?.rate | star}}</div> -->
                                                                                <img class="star-icon"
                                                                                    src="assets/img/star2.svg" alt="" />
                                                                                <span
                                                                                    class="mx-1 rateP">{{doctor?.rate}}</span>
                                                                            </div>
                                                                        </div>
                                                                        <div *ngIf="!doctor?.isMedicalServicesOverSize"
                                                                            class="clinic-services">
                                                                            <span class="doc-service mx-1"
                                                                                *ngFor="let docSRV of doctor.medicalServices">{{docSRV.name}}</span>
                                                                        </div>
                                                                        <div *ngIf="doctor?.isMedicalServicesOverSize"
                                                                            class="clinic-services">
                                                                            <span class="doc-service mx-1"
                                                                                *ngFor="let docSRV of doctor.medicalServices | slice :0:5">{{docSRV.name}}</span>
                                                                            <span
                                                                                (click)="doctor.isMedicalServicesOverSize = false"
                                                                                class="seeMore mx-1">{{'Home.ViewMore'|translate}}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="row mt-2">

                                                                <div class="col-12 mt-3 mb-2" *ngIf="doctor?.location">
                                                                    <p class="m-0 text-blue">
                                                                        <i class="fa fa-map-marker mr-10 text-blue"></i>
                                                                        <span class="mx-1">
                                                                            <span
                                                                                *ngIf="!doctor?.location?.parentName">{{doctor?.location?.name}}</span>
                                                                            <span
                                                                                *ngIf="doctor?.location?.parentName">{{doctor?.location?.parentName}}
                                                                                - {{doctor?.location?.name}}</span>
                                                                        </span>
                                                                    </p>
                                                                </div>

                                                                <div class="col-12 mb-2">
                                                                    <!-- <p class="m-0 text-blue">
                                                                        <i class="fa fa-phone mr-10 text-blue"></i>
                                                                        {{'doctorProfile.iHosPhoneNumber'|translate}}
                                                                    </p> -->
                                                                    <p class="m-0">
                                                                        <i class="fa fa-phone mx-10 text-blue callIcon"></i>
                                                                        <!-- +({{doctorDetails?.mobileNumber |slice:0:3}})
                                                                          0{{doctorDetails?.mobileNumber |
                                                                          slice:3:doctorDetails?.mobileNumber.length}} -->
                                                                        <!-- {{ "doctorProfile.iHosPhoneNumber" | translate }} -->
                                                                        <span class="callUsPGG">{{ "doctorProfile.callOn" | translate }}</span>
                                                                        <span class="callUsP">{{ "doctorProfile.iHosPhoneNumberAlone" | translate }}</span>
                                                                        <span class="callUsPGG">{{ "doctorProfile.callOn2" | translate }}</span>
                                                                      </p>
                                                                </div>

                                                                <!-- <div class="col-12 mb-2 d-flex-start">
                                                                    <ngx-star-rating [(ngModel)]="doctor.rate"
                                                                        [disabled]="true"></ngx-star-rating>
                                                                </div> -->

                                                                <div class="d-flex justify-content-start mx-1">
                                                                    <button (click)="app.routeToDoctorProfile(doctor)"
                                                                        class="btn view-profile col-12">{{
                                                                        'SearchDoctor.ViewProfile' | translate
                                                                        }}</button>
                                                                </div>



                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4 text-center">
                                                        <div class="row">
                                                            <div class="clinic-booking w-100 col-12 m-auto">

                                                                <!-- <button *ngIf="!this.app.getUserData()"
                                                                    matTooltip="You must be logged in"
                                                                    (click)="notLoggedInDialog()"
                                                                    class="btn submit-btn col-12 mb-4 w-100 btn-dis">{{
                                                                    'SearchDoctor.BookAppointment' | translate }}
                                                                </button> -->

                                                                <!-- <button
                                                                    *ngIf="this.app.getUserData() && !this?.app?.isContributor && !this?.app?.IsSocialMediaManager"
                                                                    (click)="medicalServicePopUp(doctor,doctor?.medicalServices)"
                                                                    class="btn submit-btn col-12 mb-4 w-100">{{
                                                                    'SearchDoctor.BookAppointment' | translate }}
                                                                </button> -->


                                                                <div class="d-flex justify-content-end">
                                                                    <div>
                                                                        <div class="sharedBox"
                                                                        [matTooltip]="doctor?.hasClinicServices == false ? notAvailableText : ''"
                                                                            (click)="routeToBookingBasedOnClassification(3,doctor?.hasClinicServices,doctor)"
                                                                            [ngClass]="doctor?.hasClinicServices == true ? 'trueService' : 'notTrueService'">
    
                                                                            <i class="mx-1">
                                                                                <img class="service-icon"
                                                                                    src="assets/img/newIcons/clinic.png"
                                                                                    alt=""></i>
    
                                                                            <p class="m-0 classificationP mx-1"
                                                                                [ngClass]="doctor?.hasClinicServices == true ? 'trueServiceColor' : 'notTrueServiceColor'">
                                                                                {{'SearchDoctor.clinicVisit' |
                                                                                translate}}</p>
                                                                        </div>
    
                                                                        <div class="sharedBox my-2"
                                                                        [matTooltip]="doctor?.hasVideoServices == false ? notAvailableText : ''"
                                                                            (click)="routeToBookingBasedOnClassification(2,doctor?.hasVideoServices,doctor)"
                                                                            [ngClass]="doctor?.hasVideoServices == true ? 'trueService' : 'notTrueService'">
                                                                            <i class="mx-1"><img class="service-icon"
                                                                                    src="assets/img/newIcons/online.png"
                                                                                    alt=""></i>
    
                                                                            <p class="m-0 classificationP mx-1"
                                                                                [ngClass]="doctor?.hasVideoServices == true ? 'trueServiceColor' : 'notTrueServiceColor'">
                                                                                {{'SearchDoctor.onlineConsult' |
                                                                                translate}}</p>
                                                                        </div>
    
                                                                        <div class="sharedBox"
                                                                        [matTooltip]="doctor?.hasVisitServies == false ? notAvailableText : ''"
                                                                            (click)="routeToBookingBasedOnClassification(1,doctor?.hasVisitServies,doctor)"
                                                                            [ngClass]="doctor?.hasVisitServies == true ? 'trueService' : 'notTrueService'">
                                                                            <i class="mx-1"><img class="service-icon"
                                                                                    src="assets/img/newIcons/home.png"
                                                                                    alt=""></i>
                                                                            <p class="m-0 classificationP mx-1"
                                                                                [ngClass]="doctor?.hasVisitServies == true ? 'trueServiceColor' : 'notTrueServiceColor'">
                                                                                {{'SearchDoctor.homeVisit' | translate}}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <p class="col-12 m-0 mt-2 text-align-end">
                                                                    <!-- <i class="fa fa-exclamation mr-15 text-blue ml-15"></i> -->
                                                                    <!-- <mat-icon class="material-symbols-outlined expl-icon" >error</mat-icon> -->

                                                                    <span class="gray-t">{{
                                                                        'SearchDoctor.Feesforthisdoctor' | translate }}
                                                                    </span>
                                                                    <span class="text-blue font-bold">
                                                                        {{doctor.price}} {{ 'SearchDoctor.JD' |
                                                                        translate }}
                                                                    </span>
                                                                    <span class="gray-t toBlock">({{
                                                                        'SearchDoctor.Doesnotincludeprocedures' |
                                                                        translate }})
                                                                    </span>
                                                                </p>

                                                                <!-- <p class="gray-t col-12 m-0 d-flex-justifyCenter">{{
                                                                    'SearchDoctor.Doesnotincludeprocedures' | translate
                                                                    }}</p> -->


                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- /Doctor Widget -->
                                    </div>
                                </div>

                            </div>
                            <!-- /content-right-->
                        </div>
                        <!-- /row-->
                    </div>
                </div>
                <!-- /Page Content -->

            </div>
        </div>
    </div>

</div>
<!-- /Page Content -->



<!-- <SSR> -->
<div *ngIf="app?.isPlatformServerVar"
    style="display: none !important;visibility:hidden !important;opacity: 0 !important;">

    <h1>{{headerTwo}}</h1>

    <p *ngIf="router?.url?.includes('/en/')">Call 0789642222 if you need help</p>
    <p *ngIf="router?.url?.includes('/ar/')">اتصل على ۰۷۸۹٦٤۲۲۲۲ اذا كنت بحاجة الى المساعدة</p>
    <div *ngFor="let doctor of doctors">
        <img title="{{doctor?.fullName}} - {{ doctor?.speciality }}" [src]="app.getUserImage2(doctor?.picture)"
            alt="{{doctor?.fullName}} - {{ doctor?.speciality }}" />
        <h4>{{doctor?.fullName}}</h4>
        <h5>{{ doctor?.speciality}}</h5>
        <span *ngFor="let docSRV of doctor?.medicalServices">{{docSRV?.name}}</span>
        <p>{{doctor?.country?.name}}, {{doctor?.city}}</p>
        <p>{{doctor?.rate}}</p>
        <p *ngIf="router?.url?.includes('/en/')">{{doctor?.price}} JD</p>
        <p *ngIf="router?.url?.includes('/ar/')">{{doctor?.price}} د.أ</p>

    </div>

    <!-- <SSR> -->
    <div style="display: none;visibility:hidden;opacity: 0;">
        <h4 *ngFor="let item of languages">{{item.name}}</h4>
    </div>
    <!-- </SSR> -->

    <!-- <SSR> -->
    <div style="display: none;visibility:hidden;opacity: 0;">
        <h4 *ngFor="let item of healthCareInsurance">{{item.name}}</h4>
    </div>
    <!-- </SSR> -->

    <!-- <SSR> -->
    <div style="display: none;visibility:hidden;opacity: 0;">
        <h4 *ngFor="let item of medicalServices">{{item.name}}</h4>
    </div>
    <!-- </SSR> -->

    <!-- <SSR> -->
    <div style="display: none;visibility:hidden;opacity: 0;">
        <h4 *ngFor="let item of allLocations">{{item.name}}</h4>
    </div>
    <!-- </SSR> -->

    <!-- <SSR> -->
    <div style="display: none;visibility:hidden;opacity: 0;" *ngIf="app.isPlatformServerVar">
        <p *ngIf="router?.url?.includes('/en/')">Male</p>
        <p *ngIf="router?.url?.includes('/en/')">Female</p>
        <p *ngIf="router?.url?.includes('/ar/')">ذكر</p>
        <p *ngIf="router?.url?.includes('/ar/')">انثى</p>
    </div>
    <!-- </SSR> -->

    <div>
        <p>0789642222</p>
        <p *ngIf="router?.url?.includes('/en/')">book Our Best Doctors</p>
        <p *ngIf="router?.url?.includes('/ar/')">احجز عند أفضل الأطباء لدينا</p>
        <p *ngIf="router?.url?.includes('/ar/')">ابحث عن أفضل الأطباء</p>
        <p *ngIf="router?.url?.includes('/en/')">search for best doctors</p>
        <p>Our Services</p>
        <p>خدماتنا</p>
    </div>



</div>
<!-- </SSR> -->